// axios
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';
import { DATA_SOURCES } from '../constants/appDataSources';
import { applyAuthToConfig } from 'services/auth/authTransport';
import { getApiBaseUrl } from 'services/config/runtimeConfig';

interface AzureFunctionRequestConfig extends AxiosRequestConfig {
  appDataSourceId?: string;
}

/**
 * Makes a request to an azure function without user authentication.
 * @param {AxiosRequestConfig} requestConfig Axios request config. Only the `url` is required. For all available options see https://axios-http.com/docs/req_config.
 */
const callAzureFunctionPublic = async <T = unknown,>(requestConfig: AzureFunctionRequestConfig): Promise<AxiosResponse<T>> => {
  // Destructure appDataSourceId and other params from requestConfig
  const { appDataSourceId, params = {}, ...axiosConfig } = requestConfig;

  // Add appDataSourceId to params if it is provided and not 'default'
  const updatedParams = {
    ...params,
    ...(appDataSourceId && appDataSourceId !== DATA_SOURCES.default.id ? { appDataSourceId } : {})
  };

  return axios(
    applyAuthToConfig({
      ...axiosConfig,
      params: updatedParams, // use updated params with optional appDataSourceId
      baseURL: getApiBaseUrl()
    })
  );
};

export default callAzureFunctionPublic;
